/*
 * Copyright © 2020-2024 Ocean Galaxy Inc. All Rights Reserved.
 * @Description:
 * @LastEditors: yongqiang
 * @LastEditTime: 2024-01-12 16:34:38
 */
import React, { useMemo } from 'react'
import { Button, Table } from 'antd'
const { Column } = Table

// 多级选项数据
interface CascadeData {
  cascade1: string
  cascade2: string
  cascade3: string
}

interface CascadeDataWithKey extends CascadeData {
  key: number
}

interface PreviewProps {
  data: CascadeData[]
  onImportClick: () => void
}

const Preview: React.FC<PreviewProps> = ({ data, onImportClick }) => {
  const records: CascadeDataWithKey[] = useMemo(() => {
    return data.map((record, index) => ({
      ...record,
      key: index + 1
    }))
  }, [data])

  return (
    <div className="preview-wrapper">
      <div className="import-info">
        <div className="info-title">
          选项信息预览
          <Button
            style={{ float: 'right' }}
            type="primary"
            onClick={() => {
              onImportClick()
            }}
          >
            确认导入
          </Button>
        </div>
      </div>
      <div className="table-container">
        <Table
          bordered
          dataSource={records}
          scroll={{ y: window.innerHeight - 500 }}
          style={{ margin: '0 20px' }}
          pagination={false}
        >
          <Column
            title="序号"
            key="key"
            dataIndex="key"
            render={(key: number) => {
              return key
            }}
          />
          <Column
            title="选项内容（1级选项）"
            key="cascade1"
            dataIndex="cascade1"
          />
          <Column title="2级选项" key="cascade2" dataIndex="cascade2" />
          <Column title="3级选项" key="cascade3" dataIndex="cascade3" />
        </Table>
      </div>
    </div>
  )
}

export default Preview
